import freeEmailDomains from 'free-email-domains'
import { z } from 'zod'

// TODO add corporate email validation for all emails
export const corporateEmailSchema = z
  .email()
  .refine(
    email => !freeEmailDomains.includes(email.split('@')[1]),
    'Invalid email domain'
  )
